export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discount code"])},
        "apply": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apply"])},
        "nonApplicable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This discount code is non applicable"])}
      },
      "de": {
        "code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rabattcode"])},
        "apply": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anwenden"])},
        "nonApplicable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dieser Rabattcode ist nicht anwendbar"])}
      }
    }
  })
}